export default __webpack_public_path__ + "static/media/titleEN.8bc0e264.png";